import { render, staticRenderFns } from "./AppPublishButton.vue?vue&type=template&id=0999641c&"
import script from "./AppPublishButton.vue?vue&type=script&lang=js&"
export * from "./AppPublishButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports